import { createRouter, createWebHistory } from 'vue-router'
// Layouts
import MainLayout from '@/views/Layouts/MainLayout'
import AuthLayout from '@/views/Layouts/AuthLayout'
// Auth
import Login from '@/views/Auth/Login'
// Views
import Map from '@/views/Map'
import Index from '@/views/Index.vue'
import Users from '@/views/Pages/Users/Users'
import Analysis from '@/views/Analysis'
import Orders from '@/views/Orders/Orders'
import Archive from '@/views/Archive/Archive'
import Stations from '@/views/Stations'
import PageNotFound from '@/views/PageNotFound'
import TicketList from '@/views/EnergoGoClub/Tickets/TicketList/TicketList'
import TicketSale from '@/views/EnergoGoClub/Tickets/TicketSale/TicketSale'
import Banner from '@/views/EnergoGoClub/Banner/List/Banner'
import BannerCompany from '@/views/EnergoGoClub/Banner/Company/Company'
import Reports from '@/views/Reports/Reports'
//Notification
import NotificationTemplate from '@/views/EnergoGoClub/Notifications/Template/NotificationTemplate'
import NotificationSchedule from '@/views/EnergoGoClub/Notifications/Schedule/NotificationSchedule'
import NotificationCategory from '@/views/EnergoGoClub/Notifications/Category/NotificationCategory'
import NotificationTopic from '@/views/EnergoGoClub/Notifications/Topic/NotificationTopic'
import PriceCampaign from '@/views/EnergoGoClub/PriceCampaign/PriceCampaign'
const routes = [
  {
    path: '',
    redirect: { name: 'Index'},
    component: MainLayout,
    children: [
      {
        path: '/',
        name: 'Index',
        component: Index,
        meta: {
          requiresAuth: true,
          title: 'Главная',
        }
      },
      {
        path: '/analysis',
        name: 'Analysis',
        component: Analysis,
        meta: {
          requiresAuth: true,
          title: 'Анализ конкурентов',
        }
      },
      {
        path: '/orders',
        name: 'Orders',
        component: Orders,
        meta: {
          requiresAuth: true,
          title: 'Просмотр заказов',
        }
      },
      {
        path: '/archive',
        name: 'Archive',
        component: Archive,
        meta: {
          requiresAuth: true,
          title: 'Архив заказов',
        }
      },
      // {
      //   path: '/users',
      //   name: 'Users',
      //   component: Users,
      //   meta: {
      //     requiresAuth: true,
      //     title: 'Клиенты',
      //   }
      // },
      {
        path: '/map',
        name: 'Map',
        component: Map,
        meta: {
          requiresAuth: true,
          title: 'Карта ЭЗС',
        }
      },
      {
        path: '/stations',
        name: 'Stations',
        component: Stations,
        meta: {
          requiresAuth: true,
          title: 'Список станции',
        }
      },
      {
        path: '/reports',
        name: 'Reports',
        component: Reports,
        meta: {
          requiresAuth: true,
          title: 'Отчеты',
        }
      },
      {
        path: 'banner',
        redirect: { name: 'Banner' },
        children: [
          {
            path: 'list',
            name: 'Banner',
            component: Banner,
            meta: {
              requiresAuth: true,
              title: 'Список баннеров',
            },
          },
          {
            path: 'company',
            name: 'BannerCompany',
            component: BannerCompany,
            meta: {
              requiresAuth: true,
              title: 'Компания',
            },
          },
        ],
      },
      {
        path: 'tickets',
        redirect: { name: 'TicketList'},
        children: [
          {
            path: 'list',
            name: 'TicketList',
            component: TicketList,
            meta: {
              requiresAuth: true,
              title: 'Управление абонементами',
            },
          },
          {
            path: 'sale',
            name: 'TicketSale',
            component: TicketSale,
            meta: {
              requiresAuth: true,
              title: 'Управление витриной',
            },
          },
        ]
      },
      {
        path: 'notification',
        redirect: { name: 'NotificationTemplate'},
        children: [
          {
            path: 'template',
            name: 'NotificationTemplate',
            component: NotificationTemplate,
            meta: {
              requiresAuth: true,
              title: 'Шаблоны',
            },
          },
          {
            path: 'schedule',
            name: 'NotificationSchedule',
            component: NotificationSchedule,
            meta: {
              requiresAuth: true,
              title: 'Запланированные',
            },
          },
          {
            path: 'category',
            name: 'NotificationCategory',
            component: NotificationCategory,
            meta: {
              requiresAuth: true,
              title: 'Категории',
            },
          },
          {
            path: 'topics',
            name: 'NotificationTopic',
            component: NotificationTopic,
            meta: {
              requiresAuth: true,
              title: 'Топики',
            },
          },
        ]
      },
      {
        path: 'price-campaigns',
        name: 'PriceCampaign',
        component: PriceCampaign,
        meta: {
          requiresAuth: true,
          title: 'Ценовые кампании',
        },
      },
      {
        path: "not-found",
        component: PageNotFound,
        meta: {
          requiresAuth: true,
          title: 'Страница не найдено',
        }
      },
      {
        path: "/:notFound",
        component: PageNotFound,
        redirect: 'not-found',
        meta: {
          requiresAuth: true,
          title: 'Страница не найдено',
        }
      },
      {
        path: "/:pathMatch(.*)*",
        component: PageNotFound,
        redirect: 'not-found',
        meta: {
          requiresAuth: true,
          title: 'Страница не найдено',
        }
      }
    ]
  },
  //   Auth
  {
    path: '',
    component: AuthLayout,
    children: [
      {
        path: 'login',
        name: 'Login',
        component: Login,
        meta: {
          requiresAuth: false,
          title: 'Вход'
        }
      },
    ]
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  linkExactActiveClass: 'exact-active',
  linkActiveClass: 'active',
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const access = localStorage.getItem('access')
  if (to.name === 'Login' && access) {
    return next({ name: 'Index' })
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!access) {
      return next({ name: 'Login' })
    } else {
      return next()
    }
  }
  return next()
})

export default router
